<script>
	// The params prop contains values matched from the URL
	export let params = {} 
	
	import { replace, push } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import BarraOperacoesRegistro from '../../componentes/BarraOperacoesRegistro.svelte';
	import { 
		API, 
		TipoEvento,
		StatusHttp, 
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS, 
		TextoFeedback } from '../../utils';

	const dispatch = createEventDispatcher();
	let projeto = {};
	let dadosUsuario;
	let opcoesOperacoes = [];
	let relatorios = [];

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projeto ...',
		});

		const resposta = await fetch(API(`visualizar-projeto-anonimizado/${params.codigo}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});
		
		const { dados } = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			projeto = dados;
			relatorios = projeto.relatorios;

			dadosUsuario = dadosUsuarioLS();

			opcoesOperacoes = [
				{
					titulo: 'Início',
					callback: () => push('#/')
				},
				{
					titulo: 'Painel',
					callback: () => push('#/painel')
				},
				{
					titulo: 'Preencher formulário de avaliação',
					callback: () => push(`#/avaliacao/preencher-formulario-avaliacao/${window.btoa(projeto.codigo.split('').reverse().join(''))}/${params.idAvaliacao}`)
				}
			];
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/projeto-inexistente');

			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	const exibirRelatorioProjeto = (objetoRelatorio) => {
		let conteudoModal = "";

		conteudoModal += objetoRelatorio.conteudo;

		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: objetoRelatorio.tipo,
			larguraMaxima: true,
			conteudo: conteudoModal
		});
	}
</script>

<TBoxInterno
	titulo={projeto.titulo} 
	subtitulo="{projeto.alocacao} &bull; {projeto.modalidade}"
	largura="12" 
	deslocamento="0">

	<p class="has-text-centered has-text-white has-background-black p-2 mb-3" style="border-radius: 14px">
		<span title="Área de atuação do projeto (alocação)">Área: {projeto.alocacao}</span> &bull;
		<span title="Modalidade do projeto">Mod.: {projeto.modalidade}</span> &bull;
		<span title="Data de criação do projeto (adicionado no sistema)">DC: {projeto.data_criacao} &bull; 
		<span title="Data da última atualização do projeto">DA: {projeto.data_ultima_atualizacao}</span>
	</p>

	<p class="is-size-4 mb-4">Descrição</p>

	<div class="notification is-info p-2 my-3">
		<p>DICA: Para abrir links em nova aba pressione e segure o botão Ctrl (control no Windows ou Linux) ou Cmd (command no Mac OS) e clique no link desejado.</p>
	</div>
	
	<div class="content">
		{@html projeto.descricao}
	</div>

	<hr>

	{#if relatorios?.length > 0}
	<br>

	<h1>Relatórios:</h1>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Tipo</th>
				<th>Adicionado em</th>
				<th class="has-text-right">Opções</th>
			</tr>
		</thead>
		<tbody>
			{#each relatorios as relatorio, i}
			<tr>
				<th>{ ++i }</th> 
				<td>{ relatorio.tipo }</td>
				<td>{ relatorio.data_criacao }</td>
				<td class="has-text-right"><button class="button  is-small is-dark is-outlined" on:click={ exibirRelatorioProjeto(relatorio) }>Ler</button></td>
			</tr>
			{/each}
		</tbody>
	</table>

	{/if}

	<BarraOperacoesRegistro opcoes={ opcoesOperacoes } />
</TBoxInterno>